"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendToWidget = exports.setFrameRef = exports.setLoaded = exports.frameRef = exports.loaded = void 0;
exports.loaded = false;
var setLoaded = function (loadedFlag) {
    if (loadedFlag === void 0) { loadedFlag = true; }
    return (exports.loaded = loadedFlag);
};
exports.setLoaded = setLoaded;
var setFrameRef = function (ref) { return (exports.frameRef = ref); };
exports.setFrameRef = setFrameRef;
var sendEventToWidget = function (data) {
    var origin = "*";
    window === null || window === void 0 ? void 0 : window.postMessage(data, origin);
};
var eventQueueClosure = function (eventQueueCb) {
    var eventQueue = [];
    return function (data) {
        if (exports.loaded === false) {
            eventQueue.push(data);
            return;
        }
        if (exports.loaded === true && (eventQueue === null || eventQueue === void 0 ? void 0 : eventQueue.length) > 0) {
            eventQueue.push(data);
            while ((eventQueue === null || eventQueue === void 0 ? void 0 : eventQueue.length) > 0) {
                eventQueueCb(eventQueue === null || eventQueue === void 0 ? void 0 : eventQueue.shift());
            }
            return;
        }
        return eventQueueCb(data);
    };
};
exports.sendToWidget = eventQueueClosure(sendEventToWidget);
